<template>
  <div class="footerView">
    <div class="top">
      <div class="wrap">
        <div class="left">
          <div class="logoText">{{ site.site_name }}</div>
          <div class="title">{{ site.bottom_title }}</div>
          <div class="content">
            {{ site.bottom_content }}
          </div>
        </div>
        <ul>
          <li>
            <div class="title">
              <router-link to="/popular-events">热门赛事</router-link>
            </div>
            <p>
              <router-link to="/event-exchange">赛事交流</router-link>
            </p>
          </li>
          <li>
            <div class="title">
              <router-link to="/photographer">摄影师</router-link>
            </div>
          </li>
          <li>
            <div class="title">
              <router-link to="/aboutus">关于我们</router-link>
            </div>
            <p>
              <router-link to="/disclaimer">免责声明</router-link>
            </p>
          </li>
        </ul>
        <div class="logo">
          <div class="title">关注我们</div>
          <img :src="site.wechat" alt="" class="wechat" />
        </div>
      </div>
    </div>
    <div class="copyright">
      {{ site.copyright }}
      <br />
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ site.beian }}</a>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "footerView",
  data() {
    return {

    };
  },
  computed: {
    ...mapState(["site"]),
  },
  mounted() {
    // this.getSite();
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.footerView {
  background: #000;
  .top .wrap {
    display: flex;
    justify-content: space-between;
    color: #fff;
    padding: 100px 0 50px;
    .left {
      width: 40%;
      .logoText {
        font-size: 44px;
        font-weight: bold;
      }
      .title {
        font-size: 30px;
        margin: 30px 0;
      }
    }
  }
  ul {
    display: flex;
    li {
      margin-left: 40px;
      .title {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        opacity: 0.9;
        line-height: 2;
      }
    }
  }
  .logo {
    width: 20%;
    padding-left: 5%;
    .wechat {
      margin-top: 10px;
    }
  }
  .copyright {
    background: #fff;
    text-align: center;
    font-size: 18px;
    padding: 15px 0;
  }
}
@media screen and (max-width: 1200px) {
  // .footerView {
  //   padding: 20px 5%;
  // }
  .footerView .top .wrap {
    padding: 50px 20px 30px;
  }
  .footerView .top .wrap .left .title {
    font-size: 20px;
    margin: 25px 0;
  }
  .footerView ul li .title {
    font-size: 20px;
  }
  .footerView ul li {
    margin-left: 40px;
  }
  .footerView .copyright {
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .footerView {
    height: auto;
  }
  .footerView ul {
    padding: 0;
    li {
      width: 100%;
    }
  }
  .footerView .top .wrap {
    display: block;
    padding: 30px 20px 30px;
  }
  .footerView .top .wrap .left {
    width: 100%;
  }
  .footerView .top .wrap .left .logo {
    font-size: 36px;
  }
  .footerView .logo {
    width: 25%;
    padding-left: 0%;
  }
  .footerView .top .wrap .left .title {
    font-size: 16px;
    margin: 13px 0;
  }
  .footerView ul {
    margin-top: 20px;
    li {
      margin-left: 0;
    }
  }
}
</style>
